import { requestInvoiceData } from "constants-lib/seo/requestInvoiceData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

export const getRequestInvoice = (schemaData) => {
  const data = schemaData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add Request Invoices JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addRequestInvoice = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-connect-with-you-quickly-to-request-an-invoice`,
    ) &&
    document.getElementById(`requestInvoice`) === null
  ) {
    const script = requestInvoiceJSONLD()
    addJSONLDToHead(script, `requestInvoice`)
  } else {
    removeElement(`requestInvoice`)
  }
}

// JSON LD template for Request Invoices
const requestInvoiceJSONLD = () => {
  const requestInvoiceTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getRequestInvoice(requestInvoiceData),
  }
  return requestInvoiceTemplate
}
